import { render, staticRenderFns } from "./SalesTaxReportList.vue?vue&type=template&id=1a505423&scoped=true&"
import script from "./SalesTaxReportList.vue?vue&type=script&lang=ts&"
export * from "./SalesTaxReportList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a505423",
  null
  
)

export default component.exports